import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vilka typer av serveringstillstånd finns?";
const SHORT_ANSWER = "Det finns stadigvarande och tillfälliga tillstånd, var och en till antingen allmänheten eller slutet sällskap, plus cateringtillstånd, pausservering, gemensam serveringsyta och provsmakning.";

export const Route = createFileRoute("/fraga/vilka-typer-av-serveringstillstand-finns")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vilka typer av serveringstillstånd finns" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Stadigvarande tillstånd löper tillsvidare. Tillfälligt tillstånd avser enstaka tidsperiod eller tillfälle. Cateringtillstånd ges till företag som regelbundet serverar i lokaler de inte själva förfogar över. Pausservering gäller i foajé till teater/konsert. Gemensam serveringsyta används av flera tillståndshavare. Provsmakning finns för tillverkare och partihandlare."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/serveringstillstand", label: "Alla tillståndstyper förklarade" }}
      related={[{"to": "/fraga/vad-kostar-ansokan", "label": "Vad kostar en ansökan om serveringstillstånd?"}, {"to": "/fraga/hur-lang-handlaggningstid", "label": "Hur lång är handläggningstiden för serveringstillstånd?"}, {"to": "/fraga/vem-behover-serveringstillstand", "label": "Vem behöver söka serveringstillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vilka typer av serveringstillstånd finns?" },
      { name: "description", content: "Det finns stadigvarande och tillfälliga tillstånd, var och en till antingen allmänheten eller slutet sällskap, plus cateringtillstånd, pausservering, gemensa…" },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vilka-typer-av-serveringstillstand-finns" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vilka-typer-av-serveringstillstand-finns" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vilka-typer-av-serveringstillstand-finns",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vilka typer av serveringstillstånd finns", url: "https://alkoholprovet.se/fraga/vilka-typer-av-serveringstillstand-finns" },
      ]),
    ],
  }),
});
